<template src="./AppFooter.html"></template>
<style lang="scss" src="./AppFooter.scss"></style>

<script>
import {SfFooter, SfImage, SfList, SfIcon} from '@storefront-ui/vue';
import {OrkReassurance, OrkSocial, OrkNewsletter} from "@/components/Ork";
import {icons} from "@/utils/icons";

export default {
  components: {
    SfImage,
    SfFooter,
    SfList,
    OrkSocial,
    OrkReassurance,
    OrkNewsletter,
    SfIcon
  },

  data() {
    return {
      icons : icons,
      loading: true,
      date:new Date().getFullYear(),
      social: [
        {
          label: 'facebook',
          link: 'http://www.facebook.com/pages/Air-France/10150136746870526?ref=ts',
          icon: icons.facebook
        },
        {
          label: 'instagram',
          link: 'http://instagram.com/airfrance',
          icon: icons.instagram
        },

        {
          label: 'pinterest',
          link: 'https://www.pinterest.fr/airfrance/',
          icon: icons.pinterest
        },
        {
          label: 'twitter',
          link: 'menuFooter.link.twitter',
          icon: icons.twitter
        },
        {
          label: 'linkedIn',
          link: 'http://www.linkedin.com/company/air-france',
          icon: icons.linkedIn
        },

        {
          label: 'youtube',
          link: 'https://www.youtube.com/airfranceonair',
          icon: icons.youtube
        },
      ],

      menuFooter1: {
        items: [
          {
            slug: '/notre-concept',
            target: '_self'
          },
            {
            slug: '/questions-frequentes',
            target: '_self'
          },
          {
            slug: '/qualite-trinitas',
            target: '_self'
          },
          {
            slug: '/offre-pour-professionnels',
            target: '_self'
          },
        ]
      },
      menuFooter2: {
        items: [
          {
            slug: '/choisir-son-oreiller',
            target: '_self'
          },
          {
            slug: '/choisir-sa-couette',
            target: '_self'
          },{
            slug: '/choisir-son-linge-de-lit',
            target: '_self'
          },
          {
            slug: '/choisir-son-garnissage',
            target: '_self'
          },
          {
            slug: '/choisir-son-surmatelas',
            target: '_self'
          }

        ]
      },
      menuFooter3: {
        items: [
          {
            slug: '/echange-retour',
            target: '_self'
          },
          {
            slug: '/livraison',
            target: '_self'
          },
           {
            slug: '/conditions-generales-de-vente',
            target: '_self'
          },
          {
            slug: '/contact',
            target: '_self'
          },
        ]
      },
      menuAnnexe: {
        items: [
                   {
            slug: '/mentions-legales',
            target: '_self'
          },
              {
            slug: '/politique-de-protection-des-donnees-personnelles',
            target: '_self'
          },
          {
            slug: '/gestion-des-cookies',
            target: '_self'
          }
        ]
      }
    }
  }
};
</script>

